import { isAxiosError } from "axios";

export const axiosErrorToStringError = (error) => {

    if (error?.response?.status) {
        switch (error.response.status) {
            case 400:
                return "400 - Requête invalide";
            case 401:
                return "401 - Non autorisé";
            case 402:
                return "402 - Paiement requis";
            case 403:
                return "403 - Interdit";
            case 404:
                return "404 - Non trouvé";
            case 405:
                return "405 - Méthode non autorisée";
            case 406:
                return "406 - Non acceptable";
            case 407:
                return "407 - Authentification proxy requise";
            case 408:
                return "408 - Délai d'attente de la requête dépassé";
            case 409:
                return "409 - Conflit";
            case 410:
                return "410 - Disparu";
            case 411:
                return "411 - Longueur requise";
            case 412:
                return "412 - Précondition échouée";
            case 413:
                return "413 - Charge utile trop volumineuse";
            case 414:
                return "414 - URI trop long";
            case 415:
                return "415 - Type de support non pris en charge";
            case 416:
                return "416 - Plage non satisfaisable";
            case 417:
                return "417 - Échec de l'attente";
            case 418:
                return "418 - Je suis une théière";
            case 422:
                return "422 - Format de données non valide";
            case 426:
                return "426 - Mise à niveau requise";
            case 500:
                return "500 - Erreur interne du serveur";
            case 501:
                return "501 - Non implémenté";
            case 502:
                return "502 - Mauvaise passerelle";
            case 503:
                return "503 - Service indisponible";
            case 504:
                return "504 - Délai d'attente de la passerelle dépassé";
            case 505:
                return "505 - Version HTTP non supportée";
            default:
                return error.response.status + " - Erreur non traitée";
        }
    } else if (isAxiosError(error)) {
        switch (error.code) {
            case "ERR_BAD_REQUEST":
                return "AxiosError - Requête invalide";
            case "ERR_NETWORK":
                return "AxiosError - Erreur réseau";
            case "ERR_BAD_OPTION_VALUE":
                return "AxiosError - Valeur invalide ou non supportée dans la configuration";
            case "ERR_BAD_OPTION":
                return "AxiosError - ption invalide dans la configuration";
            case "ECONNABORTED":
                return "AxiosError - Connexion interrompue";
            case "ETIMEDOUT":
                return "AxiosError - Délai d'attente de la connexion dépassé";
            case "ERR_FR_TOO_MANY_REDIRECTS":
                return "AxiosError - Trop de redirections successives";
            case "ERR_DEPRECATED":
                return "AxiosError - Option ou méthode obsolète";
            case "ERR_BAD_RESPONSE":
                return "AxiosError - Réponse invalide";
            case "ERR_CANCELED":
                return "";
                /* return "AxiosError - Requête annulée"; */
            case "ERR_NOT_SUPPORT":
                return "AxiosError - Option non supportée";
            case "ERR_INVALID_URL":
                return "AxiosError - URL invalide";
            default:
                return "AxiosError - Erreur non traitée";
        }
    } else {
        return "Erreur inconnue (not AxiosError)";
    }
}